import React, { FC } from "react";

import { IconProps } from "..";

import "../Icon.css";

export const IconExperimentsCreate: FC<IconProps> = ({ size = 23 }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 23 23"
    className="Icon IconExperimentsCreate"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M7.219 5.75V4.312h6.562V5.75h-.656v10.063c0 1.58-1.181 2.874-2.625 2.874s-2.625-1.293-2.625-2.875V5.75h-.656zm1.968 7.906c0 .431.263.719.657.719s.656-.287.656-.719c0-.431-.262-.719-.656-.719s-.656.288-.656.72zm1.97-2.156c-.395 0-.657-.287-.657-.719 0-.431.262-.719.656-.719s.656.288.656.72c0 .43-.262.718-.656.718zm-1.97-3.594h2.626V5.75H9.187v2.156zM20.047 4.535l-.412.987-.9.45.9.452.412.986.412-.986.9-.451-.9-.451-.412-.987zm-3.282 1.078l-.821 1.974-1.803.902 1.803.9.821 1.974.822-1.974 1.805-.9-1.805-.902-.822-1.974zm2.87 4.94l.412-.987.412.986.9.452-.9.45-.412.986-.412-.986-.9-.45.9-.451z"
    />
  </svg>
);
